import axios from "axios";

export default {
    namespaced: true,

    state: {},

    mutations: {},

    actions: {
        find(_, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/medico/prescription-schedules/${id}`)
                    .then((res) => {
                        resolve(res.data.data.prescription_schedule);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        create(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/medico/prescription-schedules", data)
                    .then((res) => {
                        resolve(res.data.data.prescription_schedule);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        update(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/medico/prescription-schedules/${data.id}`, data)
                    .then((res) => {
                        resolve(res.data.data.prescription_schedule);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        delete(_, scheduleId) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/medico/prescription-schedules/${scheduleId}`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        restore(_, scheduleId) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/medico/prescription-schedules/${scheduleId}/restore`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getScheduleTypes() {
            return new Promise((resolve, reject) => {
                axios
                    .get("/medico/prescription-schedules/schedule-types")
                    .then((res) => {
                        resolve(res.data.data.schedule_types);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getProviderTypes() {
            return new Promise((resolve, reject) => {
                axios
                    .get("/medico/prescription-schedules/provider-types")
                    .then((res) => {
                        resolve(res.data.data.provider_types);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        addItem(_, { id, form }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/medico/prescription-schedules/${id}/items`, form, {
                        headers: { "Content-Type": "multipart/form-data" },
                    })
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        deleteItem(_, { scheduleId, itemId }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/medico/prescription-schedules/${scheduleId}/items/${itemId}`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        approveItem(_, { scheduleId, itemId, comments }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/medico/prescription-schedules/${scheduleId}/items/${itemId}/approve`, { comments })
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        rejectItem(_, { scheduleId, itemId, comments }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/medico/prescription-schedules/${scheduleId}/items/${itemId}/reject`, { comments })
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },
};
